export const CLIENT_CAPABILITIES = {
  default: {
    // Maintenance Modules / Functionality
    MAINTENANCE_PAYROLL_ADDITIONS: true,
    MAINTENANCE_PAYROLL_DEDUCTIONS: true,
    MAINTENANCE_PAYROLL_ADJUSTMENTS: true,

    MAINTENANCE_FINALPAY_ADDITIONS: true,
    MAINTENANCE_FINALPAY_DEDUCTIONS: true,
    MAINTENANCE_FINALPAY_ADJUSTMENTS: true,

    HAS_REASON_CODE: true,
    HAS_EMPLOYEE_ID_UPLOAD_NORMALIZED: false,

    ALLOW_FLEXITIME: false,

    POSITION_CODE: false,
    POSITION_LABEL_REGULAR_TITLE: false,
    POSITION_UNIT_CODE: false,
    DEPARTMENT_CODE: false,
    DEPARTMENT_LABEL_UNITDEPARTMENT: false,
    SHIFTSCHEDULE_CODE: false,

    APPROVER_PER_LOCATION: false,
    DISTANTWATER_MODULE: false,
    AREAOFOPERATION_MODULE: false,

    AREAOFOPERATION_CODE: false,
    SUBAREA_CODE: false,
    VESSELFUNCTION_CODE: false,

    TIMEKEEPING_DATFILE_UPLOAD: false,
    TIMEKEEPING_TIMEENTRIES_UPLOAD: true,
    TIMEENTRIES_FIXEDLOGS_CONFIG: true,

    // ERE : Longitude, latitude :: Location rules
    LOCATION_TBL_LONGITUDE: false,
    LOCATION_TBL_LATITUDE: false,

    // RBL : BreakIn, Breakout :: TimeLogs
    TIMEKEEPING_TBL_BREAKIN: false,
    TIMEKEEPING_TBL_BREAKOUT: false,

    // RBL : VESSEL, EmployeeType : Personal Info
    TIMEKEEPING_VESSEL: false,
    TIMEKEEPING_EMPLOYEETYPE: false,


    // Display LateDuction RULE
    PAYROLL_LATEDEDUCTION: false,
    TIMEENTRIES_LATEDEDUCTION: false,
    FINALPAY_LATEDEDUCTION: false,

    EMPLOYEELIST_VESSEL: false,
    EMPLOYEELIST_EMPLOYEETYPE: false,

    EMPLOYEE_PERSONAL_EDITABLE_EMPLOYEEID: false,
    EMPLOYEE_ACCOUNT_SEAMAN_BOOK: false,
    EMPLOYEE_ACCOUNT_LICENSE_INFORMATION: false,
    EMPLOYEE_ACCOUNT_EMPLOYEE_BANK_TAXABLE_STAT: false,
    EMPLOYEE_INFORMATION_DESTINATION: false,
    EMPLOYEE_INFORMATION_EFFECTIVEDATE: false,
    EMPLOYEE_INFORMATION_UTILIZE_MSC_X_EMPLOYEETRANSACTION: false,
    EMPLOYEE_INFORMATION_UTILIZE_MSC_USE_ALLOWANCE: false,

    SALARY_TYPE_HAS_QOUTABASE: false,
    EMPLOYEE_DAILY_SALARY_HAS_SALARY_BASIC: false,

    // APPROVER_HIERARCHY
    APPROVER_HIERARCHY__FINANCIAL_APPROVERS: false, // temp disabled, enable when using later
    APPROVER_HIERARCHY__AMOUNT_THRESHOLDS: false,
    APPROVER_HIERARCHY__APPROVAL_POLICIES: false, // setup to modify the Financial/Amount Thresholds
    APPROVER_HIERARCHY__EMPLOYEE_TRANSACTION_APPROVERS: false, // Employee Transaction Approver List management
    APPROVER_HIERARCHY_RBL_SPECIFIC_CONFIRMATION_LABEL: false,

    // Request_Approval
    REQUEST_APPROVAL__FINANCIAL_REQUESTS: false, // temp disabled, enable when using later
    REQUEST_APPROVAL__EMPLOYEE_TRANSACTION_REQUESTS: false, // temp disabled, enable when using later

    // MODULE ACCESS
    ALOW_CASH_ADVANCE_MODULE: true,
    ALLOW_SALARY_ADVANCE_MODULE: false,
    ALLOW_EMPLOYEE_TRANSACTION_MODULE: false,
    ALLOW_VESSEL_201_MODULE: false,

    // OVERTIME
    ALLOW_OT_REQUEST_DATETIME: false,

    // DTR WITH OT VIEWING
    ALLOW_OT_EDIT_APPROVE: false,

    DEPARTMENT_FILTER_UI_TYPE: "picker",
    IS_DYNAMIC_FILTER: false,
    USE_NEW_ADDRESS_API: false,

    // DIM usage
    USE_DIM_EMPLOYEETYPE_DEPARTMENT: false,
    USE_DIM_DIVISION_DEPARTMENT: false,

    // FILTER Tag conditions
    IS_RBL_FILTER_TAG: false,

    // Filters Initial
    EMPLOYEE_FILTERS: ['DEPARTMENT', 'POSITION'],
    PAYROLL_EMPLOYEE_FILTERS: ['PAYTYPE', 'PAYROLLPERIOD', 'CLASSIFICATION'],
    MAINTENANCE_SALARY_FILTERS: ['DEPARTMENT', 'POSITION'],
    DTR_ADMINS_VIEW_FILTERS: ['DATE_FROM', 'DATE_TO', 'EMPLOYEE', 'COMPANY', 'CLIENT', 'CLASSIFICATION'],
    DTR_WITH_OT_VIEWING_FILTER: ['DATE_FROM', 'DATE_TO', 'LOCATION'],
    EMPLOYEE_SCHEDULE_FILTER: ['CLIENT'],
    EMPLOYEE_RELIEVER_FILTER: ['COMPANY', 'CLIENT'],
    TIME_KEEPING_FILTER: ['PAYTYPE', 'PAYROLLPERIOD', 'CLASSIFICATION', 'COMPANY', 'CLIENT', 'DEPARTMENT'],
    TAMPERED_APPROVAL_FILTER: ['PAYTYPE', 'PAYROLLPERIOD', 'CLASSIFICATION', 'COMPANY', 'CLIENT', 'DEPARTMENT'],
    UPLOAD_TIME_ENTRIES_FILTER: ['DATE_FROM', 'DATE_TO'],
    SALARY_FILTER: ['COMPANY', 'CLIENT'],
    LOAN_FILTER: ['COMPANY', 'CLIENT'],
    REQUEST_FILTER: ['COMPANY', 'CLIENT', 'DEPARTMENT'],
    LEAVE_INCENTIVE_FILTERS: ['YEAR', 'MONTH', 'CLASSIFICATION'],
  },
  ere: {
    LOCATION_TBL_LONGITUDE: true,
    LOCATION_TBL_LATITUDE: true,
    IS_DYNAMIC_FILTER: true,
    USE_NEW_ADDRESS_API: true,

    MAINTENANCE_PAYROLL_ADDITIONS: false,
    MAINTENANCE_PAYROLL_DEDUCTIONS: false,
    MAINTENANCE_PAYROLL_ADJUSTMENTS: false,
    HAS_REASON_CODE: false,
    HAS_EMPLOYEE_ID_UPLOAD_NORMALIZED: true,

    DEPARTMENT_FILTER_UI_TYPE: "dropdown",

    // Filter
    EMPLOYEE_FILTERS: ['COMPANY', 'CLIENT', 'DEPARTMENT', 'POSITION'],
    PAYROLL_EMPLOYEE_FILTERS: ['PAYTYPE', 'PAYROLLPERIOD', 'CLASSIFICATION', 'COMPANY', 'CLIENT', 'DEPARTMENT'],
    DTR_ADMINS_VIEW_FILTERS: ['DATE_FROM', 'DATE_TO', 'EMPLOYEE', 'COMPANY', 'CLIENT', 'CLASSIFICATION'],
    EMPLOYEE_SCHEDULE_FILTER: ['COMPANY', 'CLIENT'],
    EMPLOYEE_RELIEVER_FILTER: ['COMPANY', 'CLIENT'],
    TIME_KEEPING_FILTER: ['PAYTYPE', 'PAYROLLPERIOD', 'CLASSIFICATION', 'COMPANY', 'CLIENT', 'DEPARTMENT'],
    TAMPERED_APPROVAL_FILTER: ['PAYTYPE', 'PAYROLLPERIOD', 'CLASSIFICATION', 'COMPANY', 'CLIENT', 'DEPARTMENT'],
    UPLOAD_TIME_ENTRIES_FILTER: ['DATE_FROM', 'DATE_TO', 'CLASSIFICATION', 'COMPANY', 'CLIENT', 'DEPARTMENT'],
    SALARY_FILTER: ['COMPANY', 'CLIENT'],
    LOAN_FILTER: ['COMPANY', 'CLIENT'],
    DTR_WITH_OT_VIEWING_FILTER: ['COMPANY', 'CLIENT', 'DEPARTMENT', 'DATE_FROM', 'DATE_TO'],
    REQUEST_FILTER: ['COMPANY', 'CLIENT', 'DEPARTMENT'],
  },
  rbl: {
    ALLOW_FLEXITIME: false,
    POSITION_CODE: true,
    POSITION_LABEL_REGULAR_TITLE: true,
    DEPARTMENT_LABEL_UNITDEPARTMENT: true,
    POSITION_UNIT_CODE: true,
    DEPARTMENT_CODE: true,
    SHIFTSCHEDULE_CODE: true,

    DISTANTWATER_MODULE: true,
    AREAOFOPERATION_MODULE: true,

    AREAOFOPERATION_CODE: true,
    SUBAREA_CODE: true,
    VESSELFUNCTION_CODE: true,


    TIMEKEEPING_DATFILE_UPLOAD: true,
    TIMEKEEPING_TIMEENTRIES_UPLOAD: false,
    TIMEENTRIES_FIXEDLOGS_CONFIG: false,

    TIMEKEEPING_TBL_BREAKIN: true,
    TIMEKEEPING_TBL_BREAKOUT: true,

    TIMEKEEPING_VESSEL: true,
    TIMEKEEPING_EMPLOYEETYPE: true,
    EMPLOYEELIST_VESSEL: true,
    EMPLOYEELIST_EMPLOYEETYPE: true,

    EMPLOYEE_ACCOUNT_SEAMAN_BOOK: true,
    EMPLOYEE_ACCOUNT_LICENSE_INFORMATION: true,
    EMPLOYEE_ACCOUNT_EMPLOYEE_BANK_TAXABLE_STAT: true,
    EMPLOYEE_INFORMATION_DESTINATION: true,
    EMPLOYEE_INFORMATION_EFFECTIVEDATE: true,
    EMPLOYEE_INFORMATION_UTILIZE_MSC_X_EMPLOYEETRANSACTION: true,

    // APPROVER_HIERARCHY
    APPROVER_HIERARCHY__FINANCIAL_APPROVERS: true,
    APPROVER_HIERARCHY__AMOUNT_THRESHOLDS: true,
    APPROVER_HIERARCHY__EMPLOYEE_TRANSACTION_APPROVERS: true,
    APPROVER_HIERARCHY_RBL_SPECIFIC_CONFIRMATION_LABEL: true,

    // Request_Approval
    REQUEST_APPROVAL__FINANCIAL_REQUESTS: true,
    REQUEST_APPROVAL__EMPLOYEE_TRANSACTION_REQUESTS: true,

    // Module
    ALOW_CASH_ADVANCE_MODULE: false,
    ALLOW_SALARY_ADVANCE_MODULE: true,
    ALLOW_EMPLOYEE_TRANSACTION_MODULE: true,
    ALLOW_VESSEL_201_MODULE: true,

    // OVERTIME
    ALLOW_OT_REQUEST_DATETIME: true,

    // DIM usage
    USE_DIM_EMPLOYEETYPE_DEPARTMENT: true,
    USE_DIM_DIVISION_DEPARTMENT: true,

    // FILTER Tag conditions
    IS_RBL_FILTER_TAG: true, // checker if the employee type is required / changing between onshore | offshore

    // Filter
    EMPLOYEE_FILTERS: ['VESSEL', 'EMPLOYEE_TYPE'],
    PAYROLL_EMPLOYEE_FILTERS: ['PAYTYPE', 'PAYROLLPERIOD', 'CLASSIFICATION', 'DEPARTMENT', 'EMPLOYEE_TYPE', 'VESSEL',],
    // MAINTENANCE_SALARY_FILTERS: ['EMPLOYEE_TYPE', 'DEPARTMENT', 'POSITION', 'EFFECTIVE_DATE'],
    // MAINTENANCE_SALARY_FILTERS: ['COMPANY', 'CLASSIFICATION'],
    MAINTENANCE_SALARY_FILTERS: ['EFFECTIVE_DATE_MSC_HISTORY_DROPDOWN', 'EMPLOYEE_TYPE', 'DEPARTMENT_MSC_TOGGLE', 'POSITION_MSC_TOGGLE'], // MSC => Maintenance Salary Combination
    LEAVE_INCENTIVE_FILTERS: ['DEPARTMENT', 'POSITION', 'MONTH', 'YEAR'],
  },

  cvt: {
    ALLOW_FLEXITIME: true,
    EMPLOYEE_PERSONAL_EDITABLE_EMPLOYEEID: true,
    EMPLOYEE_DAILY_SALARY_HAS_SALARY_BASIC: true,

    // DTR WITH OT VIEWING
    ALLOW_OT_EDIT_APPROVE: true,
  }
};